const MIN_PEOPLE_APPLICABLE = 2;
const MAX_PEOPLE_APPLICABLE = 9;

function getRawPeopleApplicableList(value) {
  if (Array.isArray(value)) {
    return value;
  }

  return String(value || '')
    .split(',')
    .map((people) => people.trim())
    .filter((people) => people !== '');
}

function normalizePeopleApplicable(value) {
  return Number(value);
}

function parsePeopleApplicable(value) {
  return getRawPeopleApplicableList(value)
    .map(normalizePeopleApplicable)
    .filter((people) => Number.isInteger(people));
}

function stringifyPeopleApplicable(value) {
  return parsePeopleApplicable(value).join(',');
}

function hasDuplicatePeopleApplicable(value) {
  const peopleList = parsePeopleApplicable(value);
  return new Set(peopleList).size !== peopleList.length;
}

function isValidPeopleApplicable(value) {
  const rawPeopleList = getRawPeopleApplicableList(value);
  const peopleList = rawPeopleList.map(normalizePeopleApplicable);
  return peopleList.length > 0 && peopleList.every((people) => {
    return Number.isInteger(people)
      && people >= MIN_PEOPLE_APPLICABLE
      && people <= MAX_PEOPLE_APPLICABLE;
  });
}

export {
  MIN_PEOPLE_APPLICABLE,
  MAX_PEOPLE_APPLICABLE,
  parsePeopleApplicable,
  stringifyPeopleApplicable,
  hasDuplicatePeopleApplicable,
  isValidPeopleApplicable,
};
